

// client/src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const authed = sessionStorage.getItem("isLoggedIn") === "true";
  return authed ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
